import { useMemo } from 'react';

import { exportTableWidgetToHtml } from '../../../../report/widgetExportHelpers';
import type { WidgetInstanceCapabilities } from '../../../../runtime/instanceRegistry/types';
import { useRegisterWidgetInstance } from '../../../../runtime/instanceRegistry/useRegisterWidgetInstance';

// -- type definitions --

export interface TableInstanceRegistrationContext {
  readonly dashboardElementId: number;
  readonly widgetId: string;
  readonly enabled: boolean;
}

// -- hook --

/**
 * Register a table widget instance.
 *
 * The following capabilities are registered:
 * - for-report content extraction: HTML format
 */
export function useTableInstanceRegistration(
  ctx: TableInstanceRegistrationContext
): void {
  const capabilities = useMemo<WidgetInstanceCapabilities | null>(() => {
    if (!ctx.enabled) {
      return null;
    }

    return {
      dashboardElementId: ctx.dashboardElementId,
      widgetId: ctx.widgetId,
      reportExports: [
        {
          format: 'html',
          export: async () => exportTableWidgetToHtml(ctx.widgetId),
        },
      ],
    };
  }, [ctx.dashboardElementId, ctx.enabled, ctx.widgetId]);

  useRegisterWidgetInstance(capabilities);
}
